import { useMemo } from 'react';

export const useFormatTime = (timeInSeconds) => {
  return useMemo(() => {
    // Calculate minutes and seconds
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    
    // Format as mm:ss
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }, [timeInSeconds]);
};
